<template>
    <div class="view-inner">
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-light" role="status"></div>
            <p>Cargando...</p>
        </div>

        <!-- Page Header -->
        <div class="page-header">
            <h1 class="page-header-title"><i class="bi bi-truck-front"></i> Gestión de Costos Exclusivo Terrestre</h1>
            <div class="page-header-actions">
                <button class="btn-add" @click="abrirModalCostos()">
                    <i class="bi bi-plus-lg"></i> Agregar Costo
                </button>
            </div>
        </div>

        <!-- Filtros -->
        <div class="filter-card">
            <div class="row">
                <div class="col-md-2">
                    <label class="form-label">Destino</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.destino" placeholder="Buscar por destino">
                </div>
                <!-- Los tipos de unidad tienen nombres largos: más ancho para que no se recorten -->
                <div class="col-md">
                    <label class="form-label">Tipo de Unidad</label>
                    <select class="form-select form-select-sm" v-model="filtros.tipoUnidad">
                        <option value="">Todos</option>
                        <option v-for="item in tipoUnidades" :key="item.id" :value="item.id">{{ item.tipo_unidad }}</option>
                    </select>
                </div>
                <div class="col-md-auto">
                    <label class="form-label">&nbsp;</label>
                    <div class="filter-actions">
                        <button class="btn-filter" @click="filtrarCosto()"><i class="bi bi-search"></i> Buscar</button>
                        <button class="btn-clear" @click="limpiarFiltros"><i class="bi bi-x-circle"></i> Limpiar</button>
                        <button class="btn-export" @click="exportar"><i class="bi bi-file-earmark-excel"></i> Exportar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabla de costos (estándar: ESTANDAR_LISTADOS.md) -->
        <div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                                <th>Departamento</th>
                                <th>Provincia</th>
                                <th>Distrito</th>
                                <th>Tipo de Unidad</th>
                                <th class="text-end">Cantidad de Conductores</th>
                                <th class="text-end">Costo Envío (S/.)</th>
                                <th class="text-end">Lead Time</th>
                                <th class="text-end">Falso Flete (%)</th>
                                <th class="col-acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="costo in registros" :key="costo.id">

                                <td>{{ costo.departamento_nombre }}</td>
                                <td>{{ costo.provincia_nombre }}</td>
                                <td>{{ costo.distrito_nombre }}</td>
                                <td>{{ costo.tipo_unidad ? costo.tipo_unidad.tipo_unidad : "—" }}</td>
                                <td class="text-end celda-id">{{ costo.cant_conductor }}</td>
                                <td class="text-end celda-id">{{ costo.precio_servicio }}</td>
                                <td class="text-end celda-id">{{ costo.lead_time }}</td>
                                <td class="text-end celda-id">{{ costo.precio_falso_flete }}</td>
                                <td class="col-acciones">
                                    <button class="btn-icon btn-icon-edit" @click="editarCosto(costo)" title="Editar" aria-label="Editar">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-del" @click="eliminarCosto(costo)" title="Eliminar" aria-label="Eliminar">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!registros.length && !isLoading" class="empty-row">
                                <td colspan="9">No se encontraron costos</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <!-- Paginado en la base de datos (25 por página) -->
            <PaginacionListado :pagina="pagina" :total-paginas="totalPaginas" :total="totalRegistros"
                :por-pagina="porPagina" :en-pagina="registros.length" :cargando="isLoading"
                etiqueta="costos" @cambiar="cambiarPagina" />
        </div>


        <!-- Modal para agregar/editar costos -->
        <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ modoEdicion ? 'Editar Costos' : 'Agregar Costos' }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModal"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarCosto">
                            <h6 class="fw-bold text-secondary mt-3">Datos del Destino</h6>
                            <hr class="mt-1">
                            <div class="row">
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Departamento</label>
                                    <select class="form-control" @change="cargarProvincias()" v-model="departamento_id"
                                        required>
                                        <option value="">Seleccionar..</option>
                                        <option v-for="item in departamentos" :value="item.id" :key="item.id">{{
                                            item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Provincia</label>
                                    <select @change="cargarDistritos()" class="form-control" v-model="provincia_id"
                                        required>
                                        <option value="">Seleccionar..</option>
                                        <option v-for="item in provincias" :value="item.id" :key="item.id">{{
                                            item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Distrito</label>
                                    <select class="form-control" v-model="distrito_id" required>
                                        <option value="">Seleccionar..</option>
                                        <option v-for="item in distritos" :value="item.id" :key="item.id">{{ item.nombre
                                        }}</option>
                                    </select>
                                </div>
                            </div>

                            <h6 class="fw-bold text-secondary mt-5">Datos de la Unidad</h6>
                            <hr>

                            <div class="row">
                                <div class="col-md-9">
                                    <div class="mb-3">
                                        <label for="tipo_unidad" class="form-label">Tipo de Unidad <span
                                                class="text-danger">*</span></label>
                                        <select v-model="form.tipo_unidad_id" id="tipo_unidad"
                                            class="form-control font-small">
                                            <option v-for="item in tipoUnidades" :key="item.id" :value="item.id">
                                                {{ item.tipo_unidad }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="cant_conductores" class="form-label">Cantidad de Conductores<span
                                                class="text-danger">*</span></label>
                                        <input type="number" class="form-control" id="cant_conductores"
                                            v-model="form.cant_conductor"
                                            :class="{ 'is-invalid': errors.cant_conductor }" required>
                                        <div v-if="errors.cant_conductor" class="invalid-feedback">
                                            {{ errors.cant_conductor }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h6 class="fw-bold text-secondary mt-5">Datos del Costo</h6>
                            <hr>

                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="precio_servicio" class="form-label">Costo de envío (S/.)<span
                                                class="text-danger">*</span></label>
                                        <input type="number" class="form-control" id="precio_servicio"
                                            v-model="form.precio_servicio"
                                            :class="{ 'is-invalid': errors.precio_servicio }" required>
                                        <div v-if="errors.precio_servicio" class="invalid-feedback">
                                            {{ errors.precio_servicio }}
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="lead_time" class="form-label">Lead time <span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" id="lead_time" v-model="form.lead_time"
                                            :class="{ 'is-invalid': errors.lead_time }" required>
                                        <div v-if="errors.lead_time" class="invalid-feedback">
                                            {{ errors.lead_time }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="precio_falso_flete" class="form-label">Falso flete (%) <span
                                                class="text-danger">*</span></label>
                                        <input type="number" class="form-control" id="precio_falso_flete"
                                            v-model="form.precio_falso_flete"
                                            :class="{ 'is-invalid': errors.falso_flete }" required>
                                        <div v-if="errors.falso_flete" class="invalid-feedback">
                                            {{ errors.falso_flete }}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarCosto()">
                            {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>









    </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import PaginacionListado from '@/components/PaginacionListado.vue'
import paginacionServidor from '@/mixins/paginacionServidor'

export default {
    name: 'CostoTerrestreExclusivoPage',
    components: { PaginacionListado },
    mixins: [paginacionServidor],
    data() {
        return {
            isLoading: false,
            endpointListado: '/gestion-costo-terrestre-ex',
            showModal: false,
            modoEdicion: false,
            departamentos: [],
            provincias: [],
            distritos: [],
            filtros: {
                destino: '',
                tipoUnidad: '',
                tipoCosto: ''
            },
            form: {
                id: '',
                departamento: '',
                provincia: '',
                distrito: '',
                tipo_unidad_id: '',
                cant_conductor: '',
                precio_servicio: '',
                lead_time: '',
                precio_falso_flete: '',

            },
            departamento_id: '',
            provincia_id: '',
            distrito_id: '',
            tipoUnidades: [],
            errors: {}

        }
    },
    mounted() {
        this.cargarCostosTerrestreExc()
        this.cargarDepartamentos()
        this.getTipoUnidades()
    },
    methods: {
        // Filtros que se envían al API (el filtrado, orden y paginado se hacen en la base)
        parametrosFiltro() {
            return { destino: this.filtros.destino, tipo_unidad_id: this.filtros.tipoUnidad }
        },

        // Recarga la página actual (con los filtros activos) después de crear, editar o eliminar
        cargarCostosTerrestreExc() {
            return this.cargarListado()
        },
        // Exporta todos los registros filtrados (no solo la página visible)
        async exportar() {
            this.isLoading = true
            let todos = []
            try {
                todos = await this.todosLosRegistros()
            } catch (error) {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo generar el Excel. Intenta nuevamente.' })
                return
            } finally {
                this.isLoading = false
            }
            const num = v => (v === null || v === undefined || v === '' || isNaN(v) ? v : Number(v))
            const filas = [
                ['Departamento', 'Provincia', 'Distrito', 'Tipo de Unidad', 'Cantidad de Conductores', 'Costo Envío (S/.)', 'Lead Time', 'Falso Flete (%)'],
                ...todos.map(costo => [
                    costo.departamento_nombre,
                    costo.provincia_nombre,
                    costo.distrito_nombre,
                    costo.tipo_unidad ? costo.tipo_unidad.tipo_unidad : '',
                    num(costo.cant_conductor),
                    num(costo.precio_servicio),
                    costo.lead_time,
                    num(costo.precio_falso_flete),
                ]),
            ]
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(filas), 'Hoja1')
            XLSX.writeFile(wb, 'reporte.xlsx')
        },
        async cargarDepartamentos() {
            try {
                const response = await axios.get('/departamentos')  //
                this.departamentos = response.data.data || response.data
            } catch (error) {
                console.error('Error al cargar departamentos:', error)
            }
        },
        async cargarProvincias() {
            try {
                this.distritos = []
                const response = await axios.get('/provinciasByDepartamentos/' + this.departamento_id)
                this.provincias = response.data
            } catch (error) {
                console.error('Error al cargar provincias', error)
            }
        },
        async cargarDistritos() {
            try {
                const response = await axios.get('/distritosByProvincias/' + this.provincia_id)
                this.distritos = response.data
            } catch (error) {
                console.error('Error al cargar distritos', error)
            }
        },

        limpiarFiltros() {
            this.filtros = {
                destino: '',
                tipoUnidad: '',
                tipoCosto: ''
            }
            this.aplicarFiltros()
        },

        filtrarCosto() {
            this.aplicarFiltros()
        },

        abrirModalCostos(costo = null) {
            this.modoEdicion = !!costo
            this.errors = {}

            if (costo) {
                this.form = { ...costo }
            } else {
                this.form = {
                    id_costo: null,
                    departamento: '',
                    provincia: '',
                    distrito: '',
                    tipo_unidad_id: '',
                    cant_conductor: '',
                    precio_servicio: '',
                    lead_time: '',
                    precio_falso_flete: ''
                }
            }
            if (this.modoEdicion) {
                this.departamento_id = costo.distrito.provincia.departamento.id;
                this.cargarProvincias();
                this.provincia_id = costo.distrito.provincia.id;
                this.cargarDistritos();
                this.distrito_id = costo.distrito.id;
            }

            this.showModal = true
        },

        editarCosto(costo) {
            this.abrirModalCostos(costo)
        },

        cerrarModal() {
            this.showModal = false
            this.modoEdicion = false
            this.errors = {}
        },

        async guardarCosto() {
            try {
                this.errors = {}

                // Validaciones básicas
                if (!this.departamento_id) {
                    this.errors.departamento = 'El departamento es requerido'
                }
                if (!this.provincia_id) {
                    this.errors.provincia = 'La provincia es requerida'
                }
                if (!this.distrito_id) {
                    this.errors.distrito = 'El distrito es requerido'
                }
                if (!this.form.tipo_unidad_id) {
                    this.errors.tipo_unidad = 'El tipo de unidad es requerido'
                }
                if (!this.form.cant_conductor) {
                    this.errors.cant_conductor = 'La cantidad de conductores es requerida'
                }
                if (!this.form.precio_servicio) {
                    this.errors.precio_servicio = 'El costo de envio es requerido'
                }
                if (!this.form.lead_time.trim()) {
                    this.errors.lead_time = 'El lead time es requerido'
                }
                if (!this.form.precio_falso_flete) {
                    this.errors.falso_flete = 'El falso flete es requerido'
                }
                if (Object.keys(this.errors).length > 0) {
                    //return
                }

                this.form.ubigeo = this.distritos.find(item => item.id == this.distrito_id).ubigeo;

                let response
                if (this.modoEdicion) {
                    response = await axios.put(`/gestion-costo-terrestre-ex/${this.form.id}`, this.form)
                } else {
                    response = await axios.post('/gestion-costo-terrestre-ex', this.form)
                }



                if (response.data) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: `Costo ${this.modoEdicion ? 'actualizado' : 'registrado'} correctamente`
                    })

                    this.cerrarModal()
                    this.cargarCostosTerrestreExc()
                }
            } catch (error) {
                console.error('Error al guardar costo de envio:', error)
                if (error.response && error.response.data && error.response.data.errors) {
                    this.errors = error.response.data.errors
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.response.data.message
                    })
                }
            }
        },

        async eliminarCosto(costo) {
            try {
                const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: `Se eliminará el costo asignado a ${costo.departamento_nombre} - ${costo.provincia_nombre} - ${costo.distrito_nombre}`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar'
                })

                if (result.isConfirmed) {
                    await axios.delete(`/gestion-costo-terrestre-ex/${costo.id}`)

                    Swal.fire({
                        icon: 'success',
                        title: 'Eliminado',
                        text: 'El costo de envio ha sido eliminado correctamente'
                    })
                    this.cargarCostosTerrestreExc()
                }
            } catch (error) {
                console.error('Error al eliminar costo de envío:', error)
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo eliminar el costo de envio'
                })
            }

        },

        async getTipoUnidades() {
            try {
                let ids = [1, 2, 3, 4, 5, 6, 7];
                const params = ids.length ? { ids: ids.join(',') } : {} // Convertir array a string si hay IDs
                const response = await axios.get('tipo-unidades', { params })
                this.tipoUnidades = response.data.sort((a, b) => a.tipo_unidad.localeCompare(b.tipo_unidad))
            } catch (error) {
                console.error('Error cargando tipoUnidades:', error)
            }
        },
        buscarUnidad() {
            this.detalleUnidad = this.tipoUnidades.find(
                (item) => item.id == this.form.tipo_unidad,
            )
            this.buscarPrecio()
        },
    }
}

</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: white;
}

.modal.show {
    display: block !important;
}

.badge {
    font-size: 0.8em;
}

.text-danger {
    color: #dc3545 !important;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
}
</style>